import { render, staticRenderFns } from "./GridFormComponent.vue?vue&type=template&id=1b447abf&scoped=true&"
import script from "./GridFormComponent.vue?vue&type=script&lang=js&"
export * from "./GridFormComponent.vue?vue&type=script&lang=js&"
import style0 from "./GridFormComponent.vue?vue&type=style&index=0&id=1b447abf&lang=sass&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b447abf",
  null
  
)

export default component.exports